import { APPLICATION_NAME } from "constants/systemConstants";

export const timesheetsPages = {
  "en-US": {
    admin: {
      timesheets_page: {
        empty_list_state: {
          admin: {
            title: "No Timesheets Found",
            message: "Create an employee to start tracking time.",
            button: "Create Employee",
          },
          employee: {
            message: "No Timesheets Found.",
          },
        },
      },
      shared: {
        subscription: {
          messages: {
            activation_message: `Your trial starts when you run the first payroll that includes Timesheets and ends  after your 2nd payroll run.`,
            support_email_message:
              "If you have any questions, feel free to reach out to our support team.",
            trial_expiration_message:
              "Your free trial will end <1>after your 2nd successful payroll run</1>.",
            payment_issue_message:
              "<1>Attention:</1> A payment issue has been detected. Please resolve it within <1>{{days}} <2/></1> to avoid losing access to your Timesheets.",
          },
          components: {
            locked_state: {
              title: "Timesheets are now locked",
              message: "Subscribe to regain access.",
              button: "Activate Subscription",
            },
            pricing_section: {
              base_plan_label: "Base plan:",
              base_plan_price: "\\month <br /> (includes 3 workers)",
              additional_workers_label: "Additional workers:",
              additional_workers_price: "\\month per worker",
            },
            promo_banners: {
              benefits_section: {
                title: "Why You'll Love It:",
                list: [
                  "Easy time tracking for you and your team",
                  "Real-time insights into hours worked",
                  "Seamless integration with payroll",
                ],
              },
              free_trial: {
                title: "Introducing Timesheets – Track Time with Ease!",
                description:
                  "Effortlessly manage your team’s hours, attendance, and productivity—all in one place.",
                subtitle: "Never lose track of hours again!",
              },
              renew_subscription: {
                title: "You're missing out Paid™ Premium features",
                description: "Upgrade to Premium to regain access!",
              },
            },
            modals: {
              checkout: {
                title: `Streamline Your Payroll with ${APPLICATION_NAME}™`,
                message:
                  "Effortlessly manage your team’s hours, attendance, and productivity — all in one place.",
                footer_message:
                  "Your card will be charged 1 month after your 2nd successful payroll run",
                unpaid_invoice_alert: {
                  title: "You have an unpaid invoice",
                  description: `We’ll attempt to charge the outstanding amount of <1>{{amount}}</1> first. If successful, your subscription will then be renewed automatically.`,
                },
              },
              checkout_success: {
                title: "Congratulations! You can now use Timesheets!",
                message:
                  "Get ready to streamline your operations, boost productivity, and manage your team with ease.",
              },
              free_trial_ended: {
                title: `Your Timesheets Free Trial Will End Soon`,
                message:
                  "You've just submitted your second payroll run. Your free trial will end after two successful payroll runs.",
                message_2: `Starting next month, your subscription will cost`,
                message_3: `Billing starts on the Payroll Debit date.`,
              },
            },
            buttons: {
              start_free_trial: "Start Free Trial",
              renew_subscription: "Renew Subscription",
              upgrade_to_premium: "Upgrade to Premium",
              manage_subscription: "Manage Subscription",
              activate_subscription: "Activate Subscription",
              manage_plan: "Manage Plan",
            },
          },
        },
      },
    },
    employee: {
      shared: {
        subscription: {
          components: {
            promo_banners: {
              content_locked: {
                title: "Timesheets – Track Your Time with Ease",
                description:
                  "This feature is only available if your employer has an active subscription.",

                benefits_section: {
                  title: "Why You'll Love It:",
                  list: [
                    "Always know how many hours you’ve worked",
                    "Understand your productivity and time breakdown",
                    "Hours automatically included in payroll",
                  ],
                },

                want_to_use_alert: {
                  title: "Want to use Timesheets?",
                  description:
                    "Let your employer know! Share this page and tell them how Timesheets can help both you and your team.",
                },
              },
            },
          },
        },
      },
    },

    shared: {},
  },
};

export default timesheetsPages;
